import { FormFieldErrors } from 'global/interfaces/http.interface';
import { ComponentEvents } from '../../../../global/interfaces/component.interface';

const EVENT_PREFIX = 'MoleculeFormEvents__';


/** The type of custom events emitted in event.detail */
export type MoleculeFormEventTypes = {
	VALIDATION_RAN: boolean;
	RERUN_VALIDATION: boolean;
	/** This will be like { firstname: 'Please provide your name', address1: 'Invalid address' } */
	DISPLAY_VALIDATION_ERRORS: FormFieldErrors;
};

/** The event names for the above events */
export const MoleculeFormEvents: ComponentEvents<MoleculeFormEventTypes> = {
	/** Event emitted everytime the HTML5 validation is run */
	VALIDATION_RAN: EVENT_PREFIX + 'VALIDATION_RAN',
	RERUN_VALIDATION: EVENT_PREFIX + 'RERUN_VALIDATION',
	/** Event listener for external controllers to tell the m-form to show a list of validation errors */
	DISPLAY_VALIDATION_ERRORS: EVENT_PREFIX + 'DISPLAY_VALIDATION_ERRORS',
};
